// extracted by mini-css-extract-plugin
export default {"orderHeaderDoubleArrowWrap":"styles_orderHeaderDoubleArrowWrap__nFYIz","orderHeaderDoubleArrow":"styles_orderHeaderDoubleArrow__6chSA"};